import { SVGFC } from '@repo/toolkit/types'

const FeesSixIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.0025 7.34473C16.1228 7.45375 17.823 9.22168 17.823 11.3675V16.4944C17.823 18.7104 16.0101 20.5235 13.7941 20.5235H10.2052C7.9892 20.5235 6.17627 18.7104 6.17627 16.4944V11.3675C6.17627 9.22168 7.87639 7.45375 9.99697 7.34473"
        stroke={color}
        strokeWidth="0.777778"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6991 16.7468H12.1072C12.885 16.7468 13.5155 16.1163 13.5155 15.3387C13.5155 14.561 12.885 13.9304 12.1072 13.9304H11.8934C11.1156 13.9304 10.4853 13.3 10.4853 12.5223C10.4853 11.7447 11.1156 11.1143 11.8934 11.1143H13.3015M12.1072 17.7557V16.7467M12.1072 11.1143V10.1056M14.0031 7.50887C14.0031 7.91727 13.672 8.24828 13.2635 8.24828H10.737C10.3286 8.24828 9.99756 7.91727 9.99756 7.50887V7.1682C9.99756 6.75973 10.3286 6.42871 10.737 6.42871H13.2635C13.672 6.42871 14.0031 6.75973 14.0031 7.1682V7.50887Z"
        stroke={color}
        strokeWidth="0.777778"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1094 6.77615C9.31202 6.21233 8.64834 5.55299 9.04209 5.10002C9.86354 4.15537 10.7676 5.10002 10.7676 5.10002C10.7676 5.10002 10.0158 2.65611 12.1072 3.76533C14.1981 2.65615 13.4463 5.10002 13.4463 5.10002C13.4463 5.10002 14.3502 4.15537 15.1718 5.10002C15.5914 5.58256 14.8106 6.29979 13.9467 6.88529"
        stroke={color}
        strokeWidth="0.777778"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default FeesSixIcon
